
export type TransportationEntry = {
    id: number;
    time: string;
    title: string;
    description?: string;
}

export const FromHotelEntries: TransportationEntry[] = [
    {
        id: 1,
        time: "TBD",
        title: "Shuttle Pick up at Hotel Monaco"
    },
    {
        id: 2,
        time: "TBD",
        title: "Shuttle pick up at Homewood Suites by Hilton Pittsburgh Downtown"
    },
    {
        id: 3,
        time: "TBD",
        title: "Shuttle drop off at the WBU Event Venue",
    }
];

export const AfterCocktailEntries: TransportationEntry[] = [
    {
        id: 1,
        time: "TBD",
        title: "Shuttle Pick up at Hotel Monaco"
    },
    {
        id: 2,
        time: "TBD",
        title: "Shuttle pick up at Homewood Suites by Hilton Pittsburgh Downtown"
    },
    {
        id: 3,
        time: "TBD",
        title: "Shuttle drop off at the WBU Event Venue",
    }
];

export const ToHotelsEntries: TransportationEntry[] = [
    {
        id: 1,
        time: "TBD",
        title: "Shuttle departs the WBU Event Venue",
    },
    {
        id: 2,
        time: "TBD",
        title: "Shuttle drop off at Homewood Suites by Hilton Pittsburgh Downtown"
    },
    {
        id: 3,
        time: "TBD",
        title: "Shuttle drop off at Hotel Monaco",
    },
    {
        id: 4,
        time: "TBD",
        title: "Shuttle departs the WBU Event Venue",
    },
    {
        id: 5,
        time: "TBD",
        title: "Shuttle drop off at Homewood Suites by Hilton Pittsburgh Downtown"
    },
    {
        id: 6,
        time: "TBD",
        title: "Shuttle drop off at Hotel Monaco",
    }
];

export const AfterWeddingEntries: TransportationEntry[] = [
    {
        id: 1,
        time: "TBD",
        title: "Final shuttle departs the WBU Event Venue",
    },
    {
        id: 2,
        time: "TBD",
        title: "Shuttle drop off at Homewood Suites by Hilton Pittsburgh Downtown"
    },
    {
        id: 3,
        time: "TBD",
        title: "Shuttle drop off at Hotel Monaco",
    }
];

